import { delegationApis } from '@apis/delegationApis';
import { useQuery } from '@hooks/useQuery';

export const useDelegation = () => {
  return useQuery(['/delegation/'], () =>
    delegationApis.get('/delegation/', {}).then((r) => r[200]!),
  );
};
